<template>
<div id="background"></div>

<div id="meta-container">
  <div class="left side-box"></div>
  <div id="container-wrapper">
    <div id="container">
      <div id="nav" :style="{ height: navHeight + 'px' }" @click="goHome" role="button" aria-label="Go to home"><svg aria-hidden="true">
        <mask id="nav-mask" x="0" y="0" :width="width" height=100>
          <rect :width="width + 2" height=100 fill="white"></rect>
          <image :width="width" href="/images/lumatron_black.svg"></image>
        </mask>
        <rect :width="width + 2"
              height=100
              mask="url(#nav-mask)"
              fill="var(--bg-color)">
        </rect>

        <!-- <a href="/">
          <image class="nav-target" x=0 y=0 :width="width" href="/images/lumatron.svg"></image>
        </a> -->
        <image class="nav-target" :width="width" href="/images/lumatron.svg"></image>
      </svg></div>

      <router-view></router-view>

      <div class="horiz-box"></div>
      <div id="footer">
        <div class="black-box"></div>
        <!-- <Icon href="https://www.etsy.com/shop/marplebot"
        imagePrefix='/images/etsy' ariaLabel="Etsy shop"/> -->
        <Icon href="https://www.instagram.com/adrianmarple"
        imagePrefix='/images/instagram' ariaLabel="Instagram profile"/>
        <Icon href="mailto:adrian@marplebot.com"
        imagePrefix='/images/mail' ariaLabel="Send email"/>
        <Icon href="https://marplebot.com"
        imagePrefix='/images/marplebot' ariaLabel="marplebot.com"/>
        <div class="black-box"></div>
      </div>
    </div>
    <div class="black-box"></div>
  </div>
  <div class="right side-box"></div>
  <div id="bottom"></div>
</div>
</template>

<script>

import Icon from "@/components/Icon"

export default {
  name: 'App',
  components: {
    Icon,
  },
  data() {
    return {
      innerWidth,
    }
  },
  created() {
    let self = this
    addEventListener('resize', (event) => {
      self.innerWidth = innerWidth
      self.$forceUpdate()
    });
  },
  computed: {
    width() {
      return Math.min(700, this.innerWidth) - 48
    },
    navHeight() {
      return 72 * this.width / 654 + 48
    },
  },
  methods: {
    goHome() {
      location.href = "/"
    }
  },
}
</script>

<style>
@font-face {
  font-family: "Heading";
  font-display: swap;
  src: url('/Kanit-Light.ttf');
}

html, body, #app {
  width: 100%;
  min-height: 100vh;
}
#app {
  overflow:hidden;
}
body {
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  align-items: center;
  --bg-color: #080808;
}
a {
  text-decoration: none;
}
a, a:visited {
  color: inherit;
}

h1 {
  font-family: Heading;
  font-size: 2.5rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  filter: drop-shadow(white 0 0 5px);
}
h2 {
  font-size: 2rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  filter: drop-shadow(white 0 0 4px);
  margin-top: 0;
}
h2 a {
  text-decoration: underline;
}
h3 {
  font-size: 1.6rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  filter: drop-shadow(white 0 0 3px);
  margin-top: 0;
}
h3 a {
  text-decoration: underline;
}

@keyframes animatedBackground {
  from { transform: translate(0, 0); }
  to { transform: translate(-50%, -50%); }
}
#background {
  position: fixed;
  left: 0;
  top: 0;
  z-index: -10;
  width: 200vmax;
  height: 200vmax;
  background-image: repeating-linear-gradient(
      -45deg,
      #00f 0,
      #a0a 12.5%,
      #f00 25%,
      #a0a 37.5%,
      #00f 50%,
      #a0a 62.5%,
      #f00 75%,
      #a0a 87.5%,
      #00f 100%
    );
  background-size: 100vmax 100vmax;
  animation: animatedBackground 20s linear infinite;
  will-change: transform;
}

#nav, #footer {
  position: relative;
  width: 100%;
}
#nav::before, #footer::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid var(--bg-color);
  pointer-events: none;
}

#nav > svg, #footer {
  width: 100%;
  height: 100%;
  display: flex;
}

#nav {
  border: 24px solid var(--bg-color);
  box-sizing: border-box;
  cursor: pointer;
}
/* .nav-target {
  cursor: pointer;
  opacity: 0;
  transition: opacity .5s cubic-bezier(.08,.59,.29,.99),;
}
.nav-target:hover {
  opacity: 0.5;
} */

#footer {
  width: 100%;
  height: 64px;
}

#meta-container {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  position: relative;
}

.side-box {
  width: calc(50% - 300px);
  min-width: 50px;
  height: 100vh;
  z-index: -1;
  position: fixed;
}
.left.side-box {
  left: -50px;
  background-image: linear-gradient(to right, rgba(8,8,8,0.9) 0, var(--bg-color) 80%);
}
.right.side-box {
  right: -50px;
  background-image: linear-gradient(to left, rgba(8,8,8,0.9) 0, var(--bg-color) 80%);
}

#container-wrapper {
  max-width: 700px;
  width: 100vw;
  display: grid;
  grid-template-rows: auto 1fr;
  min-height: 100vh;
}

#container {
  width: 100%;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #f5f5f5;
  font-weight: 700;
  font-size: .5em;
  letter-spacing: 0.1em;
}

.positioner {
  position: relative;
}
.centerer {
  display: flex;
  justify-content: center;
}

.black-box {
  background-color: var(--bg-color);
  width: 100%;
  height: 100%;
}
.horiz-box {
  background-color: var(--bg-color);
  width: 100%;
  min-height: 12px;
  display: flex;
  justify-content: center;
}

.xtall {
  min-height: 300px;
}
.tall {
  min-height: 100px;
}
.medium {
  min-height: 32px;
}

.fancy-box {
  margin: 2px;
  width: calc(100% - 4px);
  background-color: var(--bg-color);
  transition: color .5s cubic-bezier(.08,.59,.29,.99),
    background-color .5s cubic-bezier(.08,.59,.29,.99);
}
a > .fancy-box:hover, a.fancy-box:hover {
  background-color: rgba(0,0,0,0.7);
  color: white;
}
.fancy-box img {
  width: 90%;
  padding: 0 5%;
}

.fancy-divider {
  width: 100%;
  height: 2px;
  border: 10px solid var(--bg-color);
  box-sizing: border-box;
}

.simple-divider {
  width: calc(100% - 32px);
  height: 2px;
  margin: 16px;
  background-color: white;
  box-sizing: border-box;
  box-shadow: 0 0 6px 3px rgba(255, 255, 255, 0.2);
}

.row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  margin: 24px 0 12px;
  width: 256px;
  height: 256px;
  border-radius: 50%;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  background-image: url("~@/assets/lumatronmain.jpg");
  box-shadow: inset 0 0 32px var(--bg-color), inset 0 0 24px var(--bg-color), inset 0 0 16px var(--bg-color);
}
.avatar.alt {
  /*background-image: url("~@/assets/Adrian.jpg");*/
}

a .basic-button {
  text-decoration: none;
}
.basic-button {
  border-radius: 0.25rem;
  padding: 0.25rem 1rem;
  margin-top: 1.5rem;
  text-align: center;
  font-size: 2rem;
  cursor: pointer;
  background-color: white;
  color: #121212;
  position: relative;
  width: fit-content;
}
.basic-button.disabled {
  background-color: #ccc;
  color: #666;
  pointer-events: none;
}

.basic-button:hover {
  /* box-shadow: 0 0.25rem 0.625rem 0.25rem rgba(255, 255, 255, 0.2); */
  color: #555;
}
.basic-button:active {
  /* box-shadow: 0 0 0.625rem 0.25rem rgba(255, 255, 255, 0.2); */
  color: #666;
  transform: translateY(0.2rem);
}

#bottom {
  position: absolute;
  width: 100%;
  height: 3px;
  bottom: -3px;
  background-color: var(--bg-color);
  z-index: -2;
}

</style>
